export default __webpack_public_path__ + "static/jane-austin-0246aa57648282d14ddf96ee49b90c8f.gif";